// Mounted once, under the store provider: the dialogs the header and the store pages open, and the polite live
// region that announces what just happened ("Added to your cart.") to screen readers.
import { CartDrawer } from "./CartDrawer";
import { AccountPicker } from "./HeaderStore";
import { useStore } from "./StoreSession";

export function StoreDialogs() {
  const store = useStore();
  if (!store.visible) return null;
  return <>
    {store.dialog === "cart" && store.signedIn && <CartDrawer/>}
    {store.dialog === "account" && store.signedIn && <AccountPicker/>}
    <div className="sr-only" role="status" aria-live="polite">{store.message}</div>
  </>;
}
